/**
 * @fileoverview B2B events catalog page.
 * @module pages/B2BEvents
 */

import { Backdrop, CircularProgress } from "@mui/material";
import B2BEventVirtualLineSchedulesModal from "../modals/B2BEventVirtualLineSchedulesModal/index.jsx";
import styles from "../styles/B2BEvents.module.css";
import { useB2BEventsPage } from "./b2bEvents/useB2BEventsPage";
import {
  BACKDROP_SPINNER_SIZE,
  BACKDROP_SPINNER_THICKNESS,
  DRAWER_LAYER_OFFSET,
} from "./b2bEvents/b2bEventsLayout";
import {
  B2BEventsFooter,
  B2BEventsHeader,
  B2BEventsList,
  B2BEventsSuccess,
} from "./b2bEvents/B2BEventsSections";

/**
 * Lists B2B events. Staff actions stay limited to users who can manage event staff.
 * @returns {JSX.Element|null}
 */
const B2BEvents = () => {
  const page = useB2BEventsPage();

  if (!page.allowed) {
    return null;
  }

  return (
    <div className={styles.container}>
      <B2BEventsHeader page={page} />
      <B2BEventsList page={page} />
      <B2BEventsFooter page={page} />
      <B2BEventsSuccess page={page} />
      <B2BEventVirtualLineSchedulesModal
        open={page.buyerSchedulesModalOpen}
        onClose={page.closeBuyerSchedulesModal}
        titleTranslationKey="pages.b2bEvents.modalOwnSchedulesTitle"
        rows={page.buyerSchedulesModalRows}
        isLoading={page.buyerSchedulesModalLoading}
        onViewVirtualLine={page.handleViewVirtualLineFromBuyerModal}
      />
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + DRAWER_LAYER_OFFSET,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          backdropFilter: "blur(4px)",
        }}
        open={page.isLoading}
      >
        <CircularProgress
          size={BACKDROP_SPINNER_SIZE}
          thickness={BACKDROP_SPINNER_THICKNESS}
          sx={{ color: "#4eabe7" }}
        />
      </Backdrop>
    </div>
  );
};

export default B2BEvents;
